import React, { Component } from "react";
import UserService from "../services/user.service";
import ModeratorMain from "./moderator-main";

export default class BoardModerator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: "",
    };
  }

  componentDidMount() {
    UserService.getModeratorBoard().then(
      (response) => {
        this.setState({
          content: response.data,
        });
      },
      (error) => {
        this.setState({
          content:
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString(),
        });
      }
    );
  }

  render() {
    return (
      <div className="grid_container">
        {this.state.content === "Moderator Content." && <ModeratorMain />}
        {this.state.content !== "Moderator Content." && (
          <span className="viewcard21">
            <h3>No Access, please login again.</h3>
          </span>
        )}
      </div>
    );
  }
}
